import { MiembroFamilia } from './../../../servicios/lugares.service';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-grupo-familiar',
  templateUrl: './grupo-familiar.component.html',
  styleUrls: ['./grupo-familiar.component.scss']
})
export class GrupoFamiliarComponent implements OnInit {

  @Input() grupoFamiliar: MiembroFamilia[];
  @Output() onCambiarInvitadosPermitidos = new EventEmitter();
  esCitofonia: boolean;
  currentFotoMiembro = null

  constructor(
    private readonly location: Location,
  ) { }

  ngOnInit(): void {
    this.esCitofonia = this.location.path().includes("citofonia");
  }
    
  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  
  handleCambiarInvitadosPermitidos(miembro: MiembroFamilia) {
    this.onCambiarInvitadosPermitidos.emit(miembro);
  }

  public telefonoWhatsApp(miembro: MiembroFamilia) {
    return miembro.indicative.substr(1) + miembro.phone;
  }

}
